export default {
	list: [],
	filter: {
		received: {
			studentName: '',
			memberName: '',
			onlyNotReadedMessages: '',
			startDate: null,
			endDate: null
		},
		sent: {
			studentName: '',
			memberName: '',
			onlyNotReadedMessages: '',
			startDate: null,
			endDate: null
		}
	},
	compose: [],
	responsible: [],
	schoolMembers: [],
	messageGroup: {
		creationUser: {},
		dateTime: '',
		members: '',
		messageGroup: '',
		messages: [],
		student: {},
		subject: '',
		users: []
	},
	unreadMessages: 0,
	messages: {
		received: [],
		sent: []
	},
	inboxAgenda: []
};



// WEBPACK FOOTER //
// ./sources/app/inbox/state.js